import CATEGORIES from 'constants/mockCategories';
import SUBJECTS   from 'constants/mockSubjects';



const DEFAULT_DIR_PATH  = dn.$store.getters['path/$join']('resources', 'data');
const DEFAULT_FILE_NAME = 'mock-subjects.json';
const SSInfo = dn.$store.getters['config/ssinfo'];


export default class MockSubject {

  static get CATEGORIES() { return JSON.parse(JSON.stringify(CATEGORIES)) }
  static get SUBJECTS() { return JSON.parse(JSON.stringify(SUBJECTS)) }



  /**
   * カテゴリーを検索
   */
  static findCategories(ids = null, tree = false) {
    ids = typeof ids === 'string' ? [ids] : ids;
    if (ids === null) {
      return this.CATEGORIES.map(category => this.getCategory(category.id, tree));
    } else {
      return ids.map(id => { return this.getCategory(id, tree) });
    }
  }



  /**
   * カテゴリーを取得
   */
  static getCategory(id, tree = false) {
    const category = this.CATEGORIES.find(category => category.id === id);
    if (tree) {
      category.subjects = this.findSubjects({categoryId: id});
    }
    return category;
  }



  /**
   * 科目を検索
   */
  static findSubjects(condition = null) {
    if (condition === null) return this.SUBJECTS;

    condition = typeof condition === 'string' ? {id: condition} : condition;

    const subjects = [];
    this.SUBJECTS.forEach(subject => {
      for (let key in condition) {
        if (subject[key] !== condition[key]) continue;
        subjects.push(subject);
      }
    });

    return subjects;
  }



  /**
   * 定義ファイルを読み込む
   */
  static async load(url) {
    // const res = await dn.$http.get(url);
    const conf = dn.$store.getters['config/ssinfo'];
    let res = {};
    if (conf.url){
      res = await dn.$http.post(conf.url, {
        dataType   : 'json',
        contentType: 'application/json; charset=utf-8',
        data       : JSON.stringify({gakunen: conf.gakunen,kai: conf.kai,nendo: conf.nendo}),
      });
    } else {
      res = await dn.$http.get(url);
    }
    return this.parseJson(res.data);
  }



  /**
   * 定義ファイルをパースする
   */
  static parseJson(json) {
    const subjects = [];
    const errors   = [];

    json.kjSSList.forEach(row => {
      const id = row.kamokuCd;

      // @memo: 科目コードの末尾が「00」になっているものは教科合計なのでスキップ
      // https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-137#comment-1178592421
      if (/00$/.test(id)) return;

      const subject = SUBJECTS.find(subject => subject.id === id);
      if (!subject) {
        errors.push(id);
        return;
      }

      subjects.push({
        id : row.kamokuCd,
        avg: parseInt(row.avg, 10) / 10,
        sd : parseInt(row.sd , 10) / 10,
        max: subject.maxScore,
      })
    });

    if (errors.length) {
      const message = `模試科目設定ファイルに記載の科目コード「${errors.join(',')}」は定義されていません。`;
      console.error(message);
      alert(message);
    }

    return subjects;
  }



  get filePath() { return this.dir + '/' + this.fileName }



  /**
   * constructor
   */
  constructor(year = dn.$store.getters['config/year'], opt = {}) {
    this.year      = year;
    this.dir       = opt.dir      || DEFAULT_DIR_PATH;
    this.fileName  = opt.fileName || DEFAULT_FILE_NAME;
    this.subjects  = null;
    this.histories = {};
  }



  /**
   * 定義ファイルを読み込んでメンバに保持する
   */
  async load() {
    this.subjects = await this.constructor.load(this.filePath);
    this.restoreHistories();
    return this.subjects;
  }



  restoreHistories() {
    this.histories = {};
    this.subjects.forEach(subject => {
      const score = dn.$ls.get(`bible-mock-input-${subject.id}`, null);
      this.histories[subject.id] = {
        score    : score,
        deviation: this.getDeviationByScoreAndSubjectId(score, subject.id),
      };
    });
  }



  /**
   * 定義ファイルをパースする
   */
  parseJson(json) {
    return this.constructor.parseJson(json);
  }



  /**
   * 科目を取得する
   */
  getSubjectById(id) {
    return this.subjects.find(subject => subject.id === id);
  }



  /**
   * 偏差値を算出する
   * ※定義ファイルがロード済みである事
   */
  getDeviationByScoreAndSubjectId(score, id) {
    if (score === null) return null;

    const define = this.getSubjectById(id);

    let dev = Math.floor((((score * 10 -define.avg * 10) * 1000 / (define.sd * 10)) + 5005) / 10);

    if (dev < 0) {
      dev = 0;
    } else if (dev <= 1990) {
      dev /= 10;
    } else {
      dev = 199;
    }

    return dev.toFixed(1);
  }



  /**
   * 偏差値から得点を算出する
   * ※定義ファイルがロード済みである事
   */
  getScoreByDeviationAndSubjectId(dev, id) {
    if (dev === null) return null;
    
    const define = this.getSubjectById(id);
    const maxScore = define.max;
    
    let score = Math.floor((((((dev * 10 - 500) * define.sd *10)) +(define.avg *10 * 100)) + 500)/1000);
    if (score < 0) {
      score = 0;
    } else if (score > maxScore) {
      score = maxScore;
    }
    return score;
  }
}


// WEBPACK FOOTER //
// ./src/js/models/MockSubject.js